
export default {
  data() {
    return {
      isSticky: false,
      isDesktop: false,
      idTypeform: "9iu2kwqp",
      heroItems: [
        "Une offre complémentaire à vos services",
        "Une rémunération attractive",
        "Un suivi et une gestion simplifiés",
      ],

      offerItems: [
        {
          title: "Site web",
          price: "49€",
          perMonth: true,
          text: `Un site internet clé en main pour booster son activité.`,
          link: "web",
          img: "offer-web.webp",
          alt: "Exemple de site internet",
        },
        {
          title: "Réseaux sociaux",
          price: "290€",
          perMonth: true,
          text: `Des campagnes attractives et impactantes pour attirer de nouveaux clients.`,
          link: "gestion-rs",
          img: "offer-cm.png",
          alt: "Exemples de posts Facebook ou Instagram",
        },
        {
          title: "Publicité Google",
          price: "299€",
          perMonth: true,
          text: `Générer plus de contact en étant dans le top des recherches Google.`,
          link: "seo",
          img: "offer-seo.webp",
          alt: "Landing page campagne Google Ads",
        },
        {
          title: "Graphisme",
          price: "199€",
          perMonth: false,
          text: `Une image professionnelle pour se différencier et marquer les esprits.`,
          link: "graphism",
          img: "offer-graphism.webp",
          alt: "Exemple de cartes de visite et logo ALEO",
        },
      ],

      whyPartner: [
        {
          text: "Fidélisez vos clients en leur apportant des solutions complémentaires à vos services",
          image: "why-partner-1.png",
          class: "col-span-2",
        },
        {
          text: "Faites leur bénéficier de tarifs préférentiels",
          image: "why-partner-2.png",
          class: "col-span-2 lg:col-span-1",
        },
        {
          text: "Bénéficiez d’une rémunération attractive",
          image: "why-partner-3.png",
          class: "col-span-2 lg:col-span-1",
        },
      ],

      bePartner: [
        {
          title: "Simple",
          content:
            "Profitez d’un parcours de partenariat fluide et suivez ses performances grâce à un tableau de bord personnalisé créé par nos experts.",
        },
        {
          title: "Efficace",
          content:
            "Propulsez l’activité de vos clients en leur proposant les meilleures solutions de communication à des tarifs préférentiels.",
        },
        {
          title: "Durable",
          content:
            "Tirez profit sur le long terme d’un partenariat gagnant/gagnant géré en toute transparence.",
        },
      ],

      forClients: [
        "Une offre professionnelle à un tarif avantageux",
        "+ de clients, + de chiffres d'affaires, + de visibilité",
        "Une gestion complète de A à Z par nos experts",
        "Pas d'investissement initial",
      ],

      faq: [
        {
          question: "Qui peut devenir partenaire ALEO ?",
          answer: `Toutes les entreprises actrices dans la réussite des entrepreneurs peuvent devenir ALEO : experts-comptables, banques, avocats d’affaires, entreprises de domiciliation, etc.<br> Si votre entreprise a pour vocation d’accompagner les entrepreneurs dans la croissance de leur entreprise, vous pouvez devenir partenaire ALEO.`,
          isCollapsed: false,
        },
        {
          question: "Pourquoi devenir partenaire ALEO ?",
          answer: `Devenir partenaire ALEO vous offre la possibilité d’orienter vos clients vers des solutions complémentaires à celles que vous proposez pour leur permettre de se développer rapidement et d’assurer leur croissance.<br> Vous aurez ainsi l’opportunité d’améliorer votre image de marque et de fidéliser vos clients en devenant acteur de leur réussite. <br> Devenir partenaire ALEO vous permet également d’obtenir une rémunération complémentaire intéressante et/ou en offrant des avantages exclusifs à vos clients.
Vous pourrez ainsi leur proposer les meilleures solutions de communication du marché tout en étant rémunéré.<br>
ALEO s’occupe de tous les supports liés aux partenariats (logos, affiches, supports de vente) mais aussi de tout le suivi statistique (lien de tracking, tableau de bord spécifique…).
`,
          isCollapsed: false,
        },
        {
          question: "Comment devenir partenaire ALEO ?",
          answer: `Vous souhaitez devenir partenaire ALEO ? Il vous suffit de remplir le formulaire de contact ci-dessus ! Un de nos responsables de partenariats prendra contact avec vous pour planifier un rendez-vous de découverte.`,
          isCollapsed: false,
        },
        {
          question: "Qu’est-ce que cela apportera à mes clients ?",
          answer: `En devenant partenaire ALEO, vous offrez à vos clients la possibilité de bénéficier de toutes nos offres à des tarifs préférentiels sans investissement initial. <br>
Vous pourrez leur apporter plus de client, plus de visibilité et donc plus de chiffre d’affaires avec des stratégies de communication gérées de A à Z par une équipe de près de 160 experts.
`,
          isCollapsed: false,
        },
        {
          question: "Que proposez-vous chez ALEO ?",
          answer: `Chez ALEO, nous proposons tous les outils de communication nécessaires au bon développement de l’activité des entrepreneurs. <br>
Sites internet, référencement Google, publicité sur Google, posts sponsorisés sur les réseaux sociaux, logos, flyers et cartes de visites. <br>
Nous offrons aux entrepreneurs la possibilité d’avoir accès au meilleur de la communication grâce à des offres accessibles, clés en main et adaptées à chaque activité.
`,
          isCollapsed: false,
        },
      ],
    };
  },

  head() {
    return {
      title: "Programme partenaire expert comptable - Agence ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez le programme partenaire ALEO et fidélisez vos clients en leur apportant les solutions de communication les mieux adaptées à leur activité.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Programme Partenaire - Agence ALEO",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez le programme partenaire ALEO et fidélisez vos clients en leur apportant les solutions de communication les mieux adaptées à leur activité.",
        },
      ],
    };
  },

  computed: {
    heroItemResponsive() {
      return this.isDesktop
        ? this.heroItems
        : this.heroItems.concat(this.heroItems);
    },
  },

  mounted() {
    window.addEventListener("scroll", this.onScroll);
    this.watchMedia();
    window
      .matchMedia("(min-width: 1024px)")
      .addEventListener("change", (event) => {
        event.matches ? (this.isDesktop = true) : (this.isDesktop = false);
      });
  },

  methods: {
    scrollSmooth() {
      document.documentElement.style.scrollBehavior = "smooth";
      setTimeout(() => {
        document.documentElement.style.scrollBehavior = "unset";
        this.toggle();
      }, 1000);
    },

    onScroll(e) {
      const header = this.$refs.header;
      const sticky = header.offsetTop;

      if (window.pageYOffset > sticky) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    },

    watchMedia() {
      window.matchMedia("(min-width: 1024px)").matches
        ? (this.isDesktop = true)
        : (this.isDesktop = false);

      window.matchMedia("(min-width: 768px)").matches
        ? (this.isTablet = true)
        : (this.isTablet = false);
    },
  },
};
